module.exports = __webpack_public_path__ + "static/media/events.89dc0a99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/events.png
// module id = 5828
// module chunks = 0